import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { navigate } from "gatsby";
import React from "react";
import { FacebookIcon, InstagramIcon, LacreiIcon2, LinkedInIcon, MailIcon } from "../../../assets/icons";
import colors from "../../../styles/themes/main";
import { Container } from "./styles";

/**
 * Componente de rodapé.
 * @param {object} props - Propriedades do componente.
 * @param {boolean} [props.hasButtonUp=true] - Indica se o botão de voltar ao topo está visível.
 * @param {boolean} [props.isLogged=false] - Indica se o usuário está logado.
 * @returns {JSX.Element} O componente Footer.
 */
export default function Footer({ hasButtonUp = true, isLogged = false }) {
  /**
   * Função para voltar para o topo.
   */
  function scrollTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  function logout() {
    if (isLogged) {
      isLogged = false;
      sessionStorage.removeItem("authToken");
      navigate("/");
    }
  }

  return (
    <Container>
      <hr aria-hidden />
      <div className="sitemap">
        <div className="icone">
          <LacreiIcon2 />
        </div>
        <div className="menu">
          <div className="links">
            <ul>
              <li>
                <a
                  href={process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL}
                  rel="noreferrer"
                  aria-label="Link para o site institucional da Lacrei Saúde"
                  onClick={logout}
                >
                  Lacrei Saúde
                </a>
              </li>
              <li>
                <a
                  href={process.env.GATSBY_PUBLIC_URL_PACIENTE}
                  rel="noreferrer"
                  aria-label="Link para o Lacrei Saúde acessado pelas pessoas usuárias"
                  onClick={logout}
                >
                  Lacrei Pessoas Usuárias
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL}/politica-de-privacidade`}
                  onClick={logout}
                  rel="noreferrer"
                  aria-label="Política de Privacidade"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL}/termos-de-uso`}
                  onClick={logout}
                  rel="noreferrer"
                  aria-label="Termos de Uso"
                >
                  Termos de Uso
                </a>
              </li>
            </ul>
          </div>
          <div className="social">
            <ul className="icons">
              <li>
                <a
                  href="https://www.facebook.com/lacrei.saude"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Link para o Facebook da Lacrei Saúde"
                >
                  <span className="social-span">
                    <FacebookIcon color={colors.colors.secondary.health_green} />
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/lacrei.saude/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Link para o Instagram da Lacrei Saúde"
                >
                  <span className="social-span">
                    <InstagramIcon color={colors.colors.secondary.health_green} />
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/lacrei/mycompany/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Link para o Linkedin da Lacrei Saúde"
                >
                  <span className="social-span">
                    <LinkedInIcon color={colors.colors.secondary.health_green} />
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={isLogged ? "mailto:suporte@lacreisaude.com.br" : "mailto: suporte@lacreisaude.com.br"}
                  rel="noreferrer"
                  aria-label="Link para o enviar e-mail para a Lacrei Saúde"
                >
                  <span className="social-span">
                    <MailIcon color={colors.colors.secondary.health_green} />
                  </span>
                </a>
              </li>
            </ul>
            <span>CNPJ: 51.265.351/0001-65</span>
          </div>
        </div>
        {hasButtonUp && (
          <div onClick={() => scrollTop()} className="arrowup" aria-label="Voltar ao topo">
            <KeyboardArrowUp />
          </div>
        )}
        <div onClick={() => scrollTop()} className="arrow-up-mobile" aria-label="Voltar ao topo">
          <KeyboardArrowUp />
        </div>
      </div>
    </Container>
  );
}
